<template>
<div>
  <div class="home" v-if="pcShow">
    <headerTitle indexInit="2"/>
    <carouselPics :pics="pics" carouselIndex="1"/>
    <div class="block_div"></div>
    <titleBlock textChinese="服务优势" textEnglish="SERVICE  ADVANCED"/>
    <div class="block_div"></div>
    <serviceAdvancedTextThree />
    <div class="block_div"></div>
    <titleBlock textChinese="业务介绍" textEnglish="BUSINESS  INTRODUCTION"/>
    <div class="block_div"></div>
    <businessIntroduction />
    <div class="block_div"></div>
    <!-- 1111 -->
    <!-- <videoBlock :videoArray="videoArray" @selectPics="selectPics" spancols="6"/> -->
    <videoBlockSelectOdd :videoArray="videoArrayOdd" @selectPics="selectPics"/>
    <div class="block_div"></div>
    <titleBlock textChinese="拍摄场地" textEnglish="shooting venue"/>
    <div class="block_div"></div>
    <shootingCommon />
    <div class="block_div"></div>
    <titleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS"/>
    <div class="block_div"></div>
    <serviceClientFour /> 
    <div class="block_div"></div>
    <footerBlock />
    <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>
  </div>
  <div v-if="!pcShow" class="wrap_mobile_bussvideo">
      <mobileHeader indexInit="2"/>
      <mobileCarousel :pics="images" carouselIndex="1"/>
      <mobileDivBlock />
      



      <mobileTitleBlock textChinese="服务优势" textEnglish="SERVICE  ADVANCED"/>
    <mobileDivBlock />
    <!-- 1 -->
    <mobileserviceAdvancedTextThree />
    <mobileDivBlock />
    <mobileTitleBlock textChinese="业务介绍" textEnglish="BUSINESS  INTRODUCTION"/>
    <mobileDivBlock />
    <!-- 1 -->
    <mobilebusinessIntroduction />
    <mobileDivBlock />
    <!-- 1 -->
    <mobilevideoBlockSelectOdd :videoArray="videoArrayOdd" @selectPics="selectPics"/>
    <mobileDivBlock />
    <mobileTitleBlock textChinese="拍摄场地" textEnglish="shooting venue"/>
    <mobileDivBlock />
    <!-- 1 -->
    <mobileshootingCommon />
    <mobileDivBlock />
    <mobileTitleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS"/>
    <mobileDivBlock />
    <!-- 1 -->
    <mobileserviceClientFour /> 
    <mobileDivBlock />
<mobilefooterBlock />
<videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlock from '@/components/serviceBlock.vue'
import videoBlock from '@/components/videoBlock.vue'
import videoBlockSelectOdd from '@/components/videoBlockSelectOdd.vue'
import serviceProgress from '@/components/serviceProgress.vue'
import serviceClientFour from '@/components/serviceClientFour.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvanced from '@/components/serviceAdvanced.vue'
import serviceAdvancedText from '@/components/serviceAdvancedText.vue'
import serviceAdvancedTextThree from '@/components/serviceAdvancedTextThree.vue'
import shootingCommon from '@/components/shootingCommon.vue'
import businessIntroduction from '@/components/businessIntroduction.vue'
import videoEachBlock from '@/components/videoEachBlock.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobileserviceAdvancedTextThree from "@/components/mobileserviceAdvancedTextThree.vue";
import mobilebusinessIntroduction from "@/components/mobilebusinessIntroduction.vue";
import mobilevideoBlockSelectOdd from "@/components/mobilevideoBlockSelectOdd.vue";
import mobileshootingCommon from "@/components/mobileshootingCommon.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobilevideoBlockSelect from "@/components/mobilevideoBlockSelect.vue";
import mobileserviceClientFour from "@/components/mobileserviceClientFour.vue";












export default {
  name: 'Home',
  data() {
    return {
      pics:[
        {url:require('@/assets/imgs/banner401.jpeg'),linerow:1,style:'text-align:left;margin-left:50px;',text:'<span style="font-size:62px;color:#e91d62">从内容到流量，<br /></span><span style="font-size:54px;color:#fff">玩转短视频传播密码</span>'},
        // {url:require('@/assets/imgs/banner02.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner03.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner04.jpeg'),text:'你好'}
      ],
      videoUrl:{},
      videoFlag:false,
      videoArray:[
       [{url:require('@/assets/video/video401.jpg'),text:'四川移动',videoUrl:require('@/assets/video/video401.mp4')},
        {url:require('@/assets/video/video402.jpg'),text:'搜狗搜索',videoUrl:require('@/assets/video/video402.mp4')},
        {url:require('@/assets/video/video403.jpg'),text:'中粮',videoUrl:require('@/assets/video/video403.mp4')},
        {url:require('@/assets/video/video404.jpg'),text:'裕园茶',videoUrl:require('@/assets/video/video404.mp4')}],
        [{url:require('@/assets/video/video405.jpg'),text:'空格电影',videoUrl:require('@/assets/video/video405.mp4')},
        {url:require('@/assets/video/video406.jpg'),text:'腾讯广告618',videoUrl:require('@/assets/video/video406.mp4')},
        {url:require('@/assets/video/video407.jpg'),text:'腾讯金融 保洁阿姨养基秘笈',videoUrl:require('@/assets/video/video407.mp4')},
        {url:require('@/assets/video/video408.jpg'),text:'优必选词典笔',videoUrl:require('@/assets/video/video408.mp4')}],
        
      ],
      videoArrayOdd:[
       {url:require('@/assets/video/video401.jpg'),text:'四川移动',videoUrl:require('@/assets/video/video401.mp4')},
        {url:require('@/assets/video/video402.jpg'),text:'搜狗搜索',videoUrl:require('@/assets/video/video402.mp4')},
        {url:require('@/assets/video/video403.jpg'),text:'中粮',videoUrl:require('@/assets/video/video403.mp4')},
        {url:require('@/assets/video/video404.jpg'),text:'裕园茶',videoUrl:require('@/assets/video/video404.mp4')},
        {url:require('@/assets/video/video405.jpg'),text:'空格电影',videoUrl:require('@/assets/video/video405.mp4')},
        {url:require('@/assets/video/video406.jpg'),text:'腾讯广告618',videoUrl:require('@/assets/video/video406.mp4')},
        {url:require('@/assets/video/video407.jpg'),text:'腾讯金融 保洁阿姨养基秘笈',videoUrl:require('@/assets/video/video407.mp4')},
        {url:require('@/assets/video/video408.jpg'),text:'优必选词典笔',videoUrl:require('@/assets/video/video408.mp4')},
      ],
      pcShow: false,
      images: [
        {url:require('@/assets/imgs/banner401.jpeg'),linerow:1,style:'text-align:left;margin-left:50px;',text:'<span style="font-size:16px;color:#e91d62">从内容到流量，<br /></span><span style="font-size:16px;color:#fff">玩转短视频传播密码</span>'},
      ],
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgress,
    serviceClientFour,
    footerBlock,
    serviceAdvanced,
    serviceAdvancedText,
    shootingCommon,
    businessIntroduction,
    serviceAdvancedTextThree,
    videoEachBlock,
    videoBlockSelectOdd,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobileserviceAdvancedTextThree,
    mobilebusinessIntroduction,
    mobilevideoBlockSelectOdd,
    mobileshootingCommon,
    mobilefooterBlock,
    mobilevideoBlockSelect,
    mobileserviceClientFour
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  methods:{
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn(){
      this.videoFlag = false
    },
    selectPics(item){
      this.videoFlag = true
      this.videoUrl.videoUrl = item.videoUrl
      console.log(this.videoUrl,'this.videoUrl')
    }
  },
}
</script>
<style lang="less">

</style>
